import { Account, AccountRepository, AccountTicket, AccountNotAuthorizedError, AccountName, AccountId, Token } from '@/Domain/Account'

const exampleToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.' +
  'yJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6Ik1hcmNvcyBzYW5kZSIsImlhdCI6MTUxNjIzOTAzM30.' +
  'Oyu5YcrMC0wKQfRYVRbk2-oagAd623-jSp6La5wWnRc'

const storedAccounts: { [key: string]: Account } = {
  'test-ticket': new Account(
    new AccountName('Test user'),
    new AccountId('69890789E'),
    new Token(exampleToken)
  )
}

async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}

export class InMemoryAccountRepository implements AccountRepository {
  async checkTicket (ticket: AccountTicket): Promise<Account> {
    await wait(400)
    const ticketValue = ticket.value()
    const foundTicket = storedAccounts[ticketValue]
    if (!foundTicket) {
      throw new AccountNotAuthorizedError('Only test-ticket allowed')
    }
    return foundTicket
  }

  async checkSession (accountId: AccountId): Promise<Account> {
    await wait(400)
    let foundTicket = null
    for (const key in storedAccounts) {
      const currentItem = storedAccounts[key]
      if (currentItem.accountId() === accountId.accountId()) {
        foundTicket = currentItem
      }
    }
    if (!foundTicket) {
      throw new AccountNotAuthorizedError('Only test-ticket allowed')
    }
    return foundTicket
  }
}
